export default __webpack_public_path__ + "static/media/i222hp.bbff7cdc.webp";